import { Box, type BoxProps } from "@mui/material";
import { pagePaddingSx } from "@/constants";

type PageScaffoldProps = BoxProps;

/**
 * Consistent page shell: standard padding; pass additional `sx` to merge.
 */
export function PageScaffold({ sx, children, ...rest }: PageScaffoldProps) {
  return (
    <Box
      sx={[
        pagePaddingSx,
        ...(sx != null ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
      {...rest}
    >
      {children}
    </Box>
  );
}
